import { createActions } from 'redux-actions';

export const messagesActions = createActions({
  CREATE_MESSAGE: (message, formik) => ({ message, formik }),
  CREATE_MESSAGE_SUCCESS: message => message,
  CREATE_MESSAGE_FAIL: error => error,
});
